'use client';
import { useState, useRef, useEffect } from 'react';

function useThrottle(/** Значение по умолчанию */ value, /** Время ограничения */ wait) {
    if (wait === void 0) wait = 200;
    var _useState = useState(value), state = _useState[0], setState = _useState[1];
    var timeout = useRef();
    var nextValue = useRef(null);
    var hasNextValue = useRef(false);
    useEffect(function() {
        if (!timeout.current) {
            setState(value);
            var timeoutCallback = function() {
                if (hasNextValue.current) {
                    hasNextValue.current = false;
                    setState(nextValue.current);
                    timeout.current = setTimeout(timeoutCallback, wait);
                } else {
                    timeout.current = undefined;
                }
            };
            timeout.current = setTimeout(timeoutCallback, wait);
        } else {
            nextValue.current = value;
            hasNextValue.current = true;
        }
    }, [
        value
    ]);
    var clearTimeout = function() {
        return window.clearTimeout(timeout.current);
    };
    useEffect(function() {
        return clearTimeout;
    }, []);
    return [
        state
    ];
}

export { useThrottle };
